<template>
	<div class="div1">
		<el-backtop target=".div1"></el-backtop>
		<!-- 头部 -->
		<Head :data="searchList"></Head>
		<!-- 中部内容 -->
		<div style="background: #F6F5F7;">
			<!-- 导航 -->
			<!-- <div class="navigation">
				<div class="navList">
					<div v-for="(item,index) in navList" :key="index" :class="index==active?'active':''" class="navName"
						@click="onNavigation(index,item)">{{ item.title }}</div>
				</div>
			</div> -->
	<!-- 第一部分 -->
				<div style="background: #fff;">
				<div class="ones tong" v-if="active==0">
					<!-- 分类导航 -->
							<div class="navigation" style="background: #FF2D55; margin-bottom: 20px; padding: 10px 0; width: 100%; position: relative;">
								<div class="navList" style="width: 1200px; margin: 0 auto; display: flex; justify-content: center; align-items: center; flex-wrap: wrap; position: relative;">
											<!-- 中间分类和全部商品 -->
											<div style="display: flex; flex-wrap: wrap; justify-content: center;">
												<div v-for="(item, index) in leftList" :key="index" style="margin: 0 15px; display: inline-block; position: relative; z-index: 1001;">
													<div class="navCategory" style="position: relative; cursor: pointer; color: #fff; padding: 5px 10px; border-radius: 4px; transition: all 0.3s ease;">
														<span class="nameCl" @click="goToProductListWithType(item.id)" style="transition: all 0.3s ease; padding: 2px 5px; display: inline-block;">{{ item.name }}</span>
													</div>
												</div>
												<div style="margin: 0 15px; display: inline-block;">
													<div class="navCategory" style="position: relative; cursor: pointer; color: #fff; padding: 5px 10px; border-radius: 4px; transition: all 0.3s ease;">
														<span class="nameCl" @click="goToProductList()" style="transition: all 0.3s ease; padding: 2px 5px; display: inline-block;">全部商品</span>
													</div>
												</div>
											</div>
											
											<!-- 右侧购物须知 -->
											<div style="margin: 0 15px; display: inline-block; position: absolute; right: 0;">
												<div class="navCategory" style="position: relative; cursor: pointer; color: #fff; padding: 8px 16px; border-radius: 4px; transition: all 0.3s ease; background: rgba(255, 255, 255, 0.2); font-weight: bold;">
													<span class="nameCl" @click="goShoppingGuide()" style="transition: all 0.3s ease; padding: 2px 5px; display: inline-block;">购物须知</span>
												</div>
											</div>
										</div>
							</div>
						<!-- </div>
						<div style="margin: 0 15px; display: inline-block;">
							<div class="navCategory" style="position: relative; cursor: pointer; color: #fff; padding: 5px 10px; border-radius: 4px; transition: all 0.3s ease;">
								<span class="nameCl" @click="goToProductList()" style="transition: all 0.3s ease; padding: 2px 5px; display: inline-block;">全部商品</span>
							</div>
						</div>
					</div>
				</div> -->
					<!-- 中间文字板块 -->
					<div class="ist is_conts" style="background: #f8f8f8; display: flex; align-items: center; justify-content: center; padding: 0 50px; width: 100%;">
						<div style="text-align: center; line-height: 1.8; font-size: 18px; color: #333;">
							<p style="font-size: 24px; font-weight: bold; margin-bottom: 20px;">全品日本直送，竭诚为您服务！</p>
							<p style="margin-bottom: 15px;">九条购(jptabako.com)，是为国内顾客代购日本商品的专门网站。通过本站或本站所提供的日本国内各大商城链接，可购入时下日本知名品牌商品以及各类最新杂货产品。</p>
							<p style="margin-bottom: 15px;">客户在本站购买的商品，将通过国际快递（EMS）或航空邮件等发送至中国国内各地，并直接送达您的手中。敬请享受居家购日本的快乐。</p>
							<p style="font-size: 20px; font-weight: bold; margin-top: 30px;">■　欢迎光临本站。いらっしゃいませ！　■</p>
						</div>
					</div>
				</div>
			</div>
			
			<!-- 第二部分 -->
			<!-- <div class="tong second" v-if="active==0">
				<div class="seconds">
					<div class="secondsleft">
						<div class="secondsleft_title" v-if="version=='zh'">{{$t('commodity.SelectedTopic')}}</div>
						<div class="secondsleft_title" v-if="version=='en'" style="font-size: 19px;">{{$t('commodity.SelectedTopic')}}</div>
						<div class="secondsleft_dixy" v-if="version=='zh'">{{$t('commodity.wantIt')}}</div>
						<div class="secondsleft_dixy" v-if="version=='en'" style="font-size: 14px;">{{$t('commodity.wantIt')}}</div>
						<div class="chakan" @click="quanbuClick()">查看全部 ></div>
					</div>
					<div class="secondsRight">
						<div v-if="index<5" class="secondsRight_list" v-for="(item,index) in secondsList" :key="index"
							@click="switchover(item)">
							<div class="secondsRight_title">{{ item.title }}</div>
							<div class="secondsRight_sm">{{ item.shuoming }}</div>
							<img class="secondsRight_img" :src="item.image_url" />
						</div>
					</div>
				</div>
			</div> -->
		
			<!-- 第三部分 -->
			<!-- <div class="tong three" v-if="active==0">
				<div class="navList2">
					<div v-for="(item,index) in navList1" :key="index" :class="index==active1?'active1':''"
						class="navName1" @click="onNavigation1(index,item)">
						{{ item.title }}
					</div>
				</div>
			</div> -->
			<!-- <div class="tong three" v-if="active!=0">
				<div class="table_main">
					<table>
						<tbody>
							<tr>
								<th class="left-th">{{$t('commodity.sort')}}</th>
								<th class="border-bt right-th">
									<div v-for="(item,index) in classList1" :key="index"
										:class="index==active3?'active2':''" class="className"
										@click="classOn1(index,item)">{{ item.title }}</div>
								</th>
							</tr>
						</tbody>
					</table>

				</div>
			</div> -->
			<div class="tong three" v-if="dataList.content.length!=0" v-infinite-scroll="load" :infinite-scroll-disabled="dataListY">
				<!-- <div style="width: 20%;display: inline-block;">
					<img src="../../assets/img/jxhw.png" style="width: 100%;height: auto;border-radius: 0;" />
				</div> -->
				<!--  删除了 	:data="dataList.content.slice(0, 20)"></goodsItem> -->
				<goodsItem v-if="title != '拼团购'" :title="title" :isVip="relationId?true: false"
				
						:data="dataList.content.slice(0, 20)"></goodsItem>
				
			</div>
				<!-- 红色部分 -->
			<div style="background: #ff0000; padding: 30px 0; margin-top: 30px;">
				<div class="tong" style="text-align: center; color: #fff;">
						<h3 style="margin-bottom: 30px; font-size: 20px;">可代购所有日本网上商城商品</h3>
					<div style="display: grid; grid-template-columns: repeat(5, 1fr); gap: 20px; margin-bottom: 30px;">
						<a href="https://www.amazon.co.jp/?language=zh_CN" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/amazon_s.jpg" alt="amazon" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.yodobashi.com/" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/yodobashi_s.jpg" alt="yodobashi" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.rakuten.co.jp/" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/rakuten_s.jpg" alt="rakuten" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://shopping.yahoo.co.jp/" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/yahoo_jp_s.jpg" alt="yahoo" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.matsukiyo.co.jp/store/online" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/matumoto_s.jpg" alt="yahoo" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.shiseido.co.jp/sw/products/auth/SWFG070010.seam?online_shohin_ctlg_kbn=2" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/shiseido_s.jpg" alt="shiseido" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.fancl.co.jp/index.html" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/fancl_s.jpg" alt="fancl" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.cosme.com/" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/cosme.jpg" alt="cosme" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://kakaku.com/" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/kakaku_s.jpg" alt="kakaku" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.askul.co.jp/" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/askul_s.jpg" alt="askul" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.qoo10.jp/" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/q0010_s.jpg" alt="q0010" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.abc-mart.net/shop/" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/abc_s.jpg" alt="abc" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.sportsauthority.jp/ec/" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/sports.jpg" alt="sports" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.muji.com/jp/ja/store" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/muji_s.jpg" alt="muji" style="max-width: 90%; max-height: 60px;">
						</a>
						<a href="https://www.hmv.co.jp/" target="_blank" style="height: 80px; background: #fff; display: flex; align-items: center; justify-content: center; text-decoration: none;">
							<img src="../../assets/ribenurl/hmv.jpg" alt="hmv" style="max-width: 90%; max-height: 60px;">
						</a>
					</div>
						<p style="font-size: 16px;">订购上述网上商城内选购的商品请→ <a href="#" @click="goToProductList()" style="color: #fff; text-decoration: underline; cursor: pointer;">【邮件订货】</a></p>
				</div>
			</div>
			<!-- <div class="tong three" v-if="dataList.content.length!=0" v-loading="tableDataLoading">
				<goodsItem v-if="title != $t('commodity.groupBuying')" :title="title" :isVip="relationId?true: false"
					:data="dataList.content"></goodsItem>
				<goodsItem3 v-if="title == $t('commodity.groupBuying')" :title="title" :isVip="relationId?true: false"
					:data="dataList.content"></goodsItem3>
			</div> -->
			<!-- <div class="tong three" v-if="dataList.content.length!=0">
				<el-pagination background style="text-align: center;padding-bottom: 50px;" layout="prev, pager, next"
					:total="dataList.totalElements" @current-change="handleCurrentChange" :current-page="page"
					:page-size="size">
				</el-pagination>
			</div> -->
			<div class="emptyWrap" v-if="dataList.content.length==0">
				<img src="../../../static/images/empty.png" alt="">
				<div style="">{{$t('commodity.none')}}</div>
		</div>
		</div>
			
			<!-- 底部 -->
			<Foots>

			
			</Foots>
		</div>
	
		
	
</template>

<script>
	import Head from '@/components/head.vue'
	import Foots from '@/components/foots.vue'
	import goodsItem from "../../components/goods-item";
	import goodsItem3 from "../../components/goods-item3";
	import {Loading} from "element-ui";
	export default {
		components: {
			Head,
			Foots,
			goodsItem,
			goodsItem3
		},
		data() {
			return {
				page: 1,
				size: 30,
				dengji: '',
				dengjides: '',
				sort: 'createAt',
				searchList: [ ],
				navList: [{
						title: '首页',
						type: ''
					},
					{
						title: '热卖榜单',
						type: ''
					},
					{
						title: '精选好物',
						type: ''
					},
					{
						title: '每日上新',
						type: ''
					},{
						title: '推荐商品',
						type: ''
					},
					{
						title: '拼团购',
						type: ''
					}
				],
			tableDataLoading:false,
				navList1: ['精选', '热卖榜单', '服装饰品', '彩妆护肤', '母婴潮童', '家居家电'],
				active: 0,
			active1: 0,
			active2: 0,
			active3: 0,
			number1: '',
			number2: '',
			number3: '',
			bannerList: [],
			leftList: [],
			allCategories: [],
			selectedCategory: null,
			secondaryCategories: [],
		
					secondsList: [{
						createAt: "2021-09-28 14:46:58",
						id: 10,
						image_url: "https://api.shengqianxiong.com.cn/indexhomebig.png",
						state: "1",
						title: "为你推荐",
						type: 40
					},
					{
						createAt: "2021-09-28 14:46:58",
						id: 10,
						image_url: "https://api.shengqianxiong.com.cn/file/uploadPath/2021/10/09/acff2de891a9742a930249c72b39e22d.png",
						state: "1",
						title: "精选好物",
						type: 40
					},
					{
						createAt: "2021-09-28 14:46:58",
						id: 10,
						image_url: "https://api.shengqianxiong.com.cn/file/uploadPath/2021/09/28/e30819f7f7d2aff2b9f824ae2a6d2c7d.png",
						state: "1",
						title: "热卖榜单",
						type: 40
					},
					{
						createAt: "2021-09-28 14:46:58",
						id: 10,
						image_url: "https://api.shengqianxiong.com.cn/file/uploadPath/2021/09/28/109f8c26ed8ecb4bfba50ea7fb13feb1.png",
						state: "1",
						title: "每日上新",
						type: 40
					},
					{
						createAt: "2021-09-28 14:46:58",
						id: 10,
						image_url: "https://api.shengqianxiong.com.cn/file/uploadPath/2021/10/09/9176a370ac14fc10820d726d0ba710f2.png",
						state: "1",
						title: "拼团购",
						type: 40
					},
				],
				dataList: {
					content: []
				},
				classList: ['全部', '女装', '男装', '美妆', '内衣', '配饰', '箱包', '鞋品', '美食', '电器', '母婴', '儿童'],
				classList1: [{
					title: '综合',
					type: 'createAt'
				}, {
					title: '销量',
					type: 'sales'
				}, {
					title: '超低价',
					type: 'price'
				}],
				relationId: this.$cookie.get('relationId'), //邀请码
				image_url: '', //头像
				nickName: '', //用户名
				invitationCode: '',
				phone: '', //电话
				isLogin: false,
				// userId : this.$cookie.get('userId'),
				dingdanCountList: {
					count1: 0,
					count2: 0,
					count3: 0,
					count4: 0,
					count5: 0,
				}, //订单数量
				type: 'createAt',
				title: '热卖榜单',

				navlist: [],
				gonggaoList: [],

				jingXuan: [],
				reMai: [],
				meiRi: [],
				pinTuan: [],
				classId:1,
				version:'zh',
				count:0,
				dataListY : false
			}
		},
		mounted() {
			this.version = 'zh'
			this.dataSelect()
			this.bannerSelect()
			this.classSelect()
			this.classSelectP()
			this.getLeftList()
			this.getHomeGongGao()
			this.getSearchList()
			if (this.userId) {
				this.getOrderCount()
				this.userSelect()
			}
			console.log('-----------------',this.$cookie.get('language'))
			var version = this.version
			setInterval(() => {
				if(this.$cookie.get('language')){
					version = this.$cookie.get('language')
				}
				if(version!=this.version){
					this.version = version
					this.dataSelect()
					this.bannerSelect()
					this.classSelect()
					this.classSelectP()
					this.getLeftList()
					this.getHomeGongGao()
					this.getSearchList()
					console.log(version,'5----tihs.version：',this.version)
					if(this.version=='en'){
						this.navList = [{title: 'Home page',type: ''},{title: 'Hot list',type: ''},{title: 'Good pick',type: ''},
										{title: 'Refresh daily',type: ''},{title: 'Recommended goods',type: ''},{title: 'group-buying',type: ''}]
						this.classList1 = [{title: 'synthesis',type: 'createAt'}, {title: 'sales',type: 'sales'}, {title: 'At rock bottom prices',type: 'price'}]
					}else{
						this.navList = [{title: '首页',type: ''},{title: '热卖榜单',type: ''},{title: '精选好物',type: ''},
										{title: '每日上新',type: ''},{title: '推荐商品',type: ''},{title: '拼团购',type: ''}]
						this.classList1 = [{title: '综合',type: 'createAt'}, {title: '销量',type: 'sales'}, {title: '超低价',type: 'price'}]
						
					}
				}
			}, 1000)
		},
		computed: {
			userId() {
				return this.$cookie.get('userId')
			},
		},
		methods: {
			getSearchList() {
				this.$http({
					url: this.$http.adornUrl('/common/type/285'), //热词
					method: 'get',
				}).then(({
					data
				}) => {
					this.searchList = data.data.value.split(',')
				})
				
			},
			getHomeGongGao() {
				this.$http({
					url: this.$http.adornUrl('/message/page/1/0/5'),
					method: 'get',
				}).then(({
					data
				}) => {
					this.gonggaoList = data.data
				})
			},
			//跳转订单页面
			goOrder() {
				if(this.userId) {
					this.$router.push({
						path: '/order'
					})
				} else {
					this.$router.push({
						path: '/login'
					})
				}
				// this.$router.push({
				// 	path: '/order'
				// })
			},
			//轮播图跳转
			bannerSkip(e) {
				window.location.href = e.linkUrl
			},
			onNavigation(index, item) {
				this.active = index
				this.active3 = 0 //重置排序

				this.title = item.title
				this.page = 1
				if (this.title == '拼团购') {
					this.sort = 'createTime'
				} else {
					this.sort = 'createAt'
				}
				if (this.active) {
					this.getDataList()
				}
			},
			getDataList() {
				let loadingInstance = Loading.service({
					lock: true,
					text: '加载中……',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				if (this.title == '热卖榜单') {
					this.$http({
						url: this.$http.adornUrl('/goods/selling'),
						method: 'get',
						params: this.$http.adornParams({
							'sort': this.sort,
							'page': this.page - 1,
							'size': this.size,
						})
					}).then(({
						data
					}) => {
						loadingInstance.close();
						if (data.status == 0) {
							// this.dataList = data.data
							if(this.page==1){
								this.dataList = data.data
								this.dataListY = false
							}else{
								if(data.data.content.length==0){
									this.dataListY = true
									console.log('this.dataListY---111--------',this.dataListY)
								}else{
									this.dataList.content = [...this.dataList.content,...data.data.content]
									this.dataListY = false
								}
								
							}
						}
					})
				} else if (this.title == '精选好物') {
					this.$http({
						url: this.$http.adornUrl('/goods/selectGoods'),
						method: 'get',
						params: this.$http.adornParams({
							'sort': this.sort,
							'page': this.page - 1,
							'size': this.size,
							'languageType': this.version
						})
					}).then(({
						data
					}) => {
						loadingInstance.close();
						if (data.status == 0) {
							// this.dataList = data.data
							if(this.page==1){
								this.dataList = data.data
								this.dataListY = false
							}else{
								if(data.data.content.length==0){
									this.dataListY = true
									console.log('this.dataListY---111--------',this.dataListY)
								}else{
									this.dataList.content = [...this.dataList.content,...data.data.content]
									this.dataListY = false
								}
								
							}
						}
					})
				} else if (this.title == '每日上新') {
					this.$http({
						url: this.$http.adornUrl('/goods/news'),
						method: 'get',
						params: this.$http.adornParams({
							'sort': this.sort,
							'page': this.page - 1,
							'size': this.size,
							'languageType': this.version
						})
					}).then(({
						data
					}) => {
						loadingInstance.close();
						if (data.status == 0) {
							// this.dataList = data.data
							if(this.page==1){
								this.dataList = data.data
								this.dataListY = false
							}else{
								if(data.data.content.length==0){
									this.dataListY = true
									console.log('this.dataListY---111--------',this.dataListY)
								}else{
									this.dataList.content = [...this.dataList.content,...data.data.content]
									this.dataListY = false
								}
								
							}
						}
					})
				} else if (this.title == '推荐商品') {
					this.$http({
						url: this.$http.adornUrl('/goods/recommend'),
						method: 'get',
						params: this.$http.adornParams({
							'sort': this.sort,
							'page': this.page - 1,
							'size': this.size,
							'languageType': this.version
						})
					}).then(({
						data
					}) => {
						loadingInstance.close();
						if (data.status == 0) {
							// this.dataList = data.data
							if(this.page==1){
								this.dataList = data.data
								this.dataListY = false
							}else{
								if(data.data.content.length==0){
									this.dataListY = true
									console.log('this.dataListY---111--------',this.dataListY)
								}else{
									this.dataList.content = [...this.dataList.content,...data.data.content]
									this.dataListY = false
								}
								
							}
						}
					})
				} else if (this.title == '拼团购') {

					this.$http({
						url: this.$http.adornUrl('/selfGroup/userList'),
						method: 'get',
						params: this.$http.adornParams({
							'sort': this.sort,
							'page': this.page - 1,
							'size': this.size,
						})
					}).then(({
						data
					}) => {
						loadingInstance.close();
						if (data.status == 0) {
							// this.dataList = data.data
							if(this.page==1){
								this.dataList = data.data
								this.dataListY = false
							}else{
								if(data.data.content.length==0){
									this.dataListY = true
									console.log('this.dataListY---111--------',this.dataListY)
								}else{
									this.dataList.content = [...this.dataList.content,...data.data.content]
									this.dataListY = false
								}
								
							}
						}
					})
				} else {
					this.$http({
						url: this.$http.adornUrl('/goods/userList'),
						method: 'get',
						params: this.$http.adornParams({
							'page': this.page - 1,
							'size': this.size,
							'sort': this.sort,
							'type': this.type,
							'languageType': this.version
						})
					}).then(({
						data
					}) => {
						loadingInstance.close();
						// this.dataList = data.data
						if(this.page==1){
							this.dataList = data.data
							this.dataListY = false
						}else{
							if(data.data.content.length==0){
								this.dataListY = true
								console.log('this.dataListY---111--------',this.dataListY)
							}else{
								this.dataList.content = [...this.dataList.content,...data.data.content]
								this.dataListY = false
							}
							
						}
					})
				}
			},
			onNavigation1(index, item) {
				this.active1 = index
				this.page = 1
				this.type = item.url.slice(item.url.indexOf('cid=') + 4, item.url.indexOf('&'))
				this.sort = 'createAt'
				this.classId = item.id
				if (item.title == '热销专区') {
					this.title = '热销专区'
					this.dataSelect()
				}else if (item.title == '热卖榜单') {
					this.title = '热卖榜单'
					this.dataSelect()
				} else if (item.title == '精选好物') {
					this.title = '精选好物'
					this.dataSelect()
				} else {
					this.title = ''
					this.dataSelect()
				}
			},
			classOn(index) {
				this.active2 = index
			},
			classOn1(index, item) {
				this.active3 = index
				this.sort = item.type
				if (this.title == '拼团购' && this.active3 == 1) {
					this.sort = 'groupNumber'
				}
				this.getDataList()
			},
			onClick(id) {
					// 检查allCategories是否存在
					if (!this.allCategories || !Array.isArray(this.allCategories)) {
						// 如果allCategories不存在，直接跳转到商品列表页面
						this.$router.push({
							path: '/productList?type=' + id
						})
						return;
					}
					
					// 查找当前分类
					const category = this.allCategories.find(item => item.id === id);
					if (category) {
						// 从children数组中获取二级分类
						const secondaryCategories = category.children || [];
						console.log('二级分类:', secondaryCategories);
						
						if (secondaryCategories.length > 0) {
							// 如果有二级分类，显示二级分类列表
							this.selectedCategory = category;
							this.secondaryCategories = secondaryCategories;
						} else {
							// 如果没有二级分类，直接跳转到商品列表页面
							this.$router.push({
								path: '/productList?type=' + id
							})
						}
					} else {
						// 如果找不到分类，直接跳转到商品列表页面
						this.$router.push({
							path: '/productList?type=' + id
						})
					}
				},
			handleCurrentChange(val) {
				this.page = val
				if (this.active == 0) {
					this.dataSelect()
				} else {
					this.getDataList()
				}
			},
			quanbuClick() {
				console.log('点击查看全部')
			},
			// 商品数据分类
			classSelect() {
				this.$http({
					url: this.$http.adornUrl('/selfActivity/list'),
					method: 'get',
					params: this.$http.adornParams({
						'languageType': this.version
					})
				}).then(({
					data
				}) => {
					// this.navList1 = data.data

					this.navlist = [];
					this.jingXuan = [];
					this.reMai = [];
					this.meiRi = [];
					this.pinTuan = [];
					this.secondsList = []
					
					data.data.forEach(d => {
						if(d.url){
							const str = d.url.substr(d.url.indexOf("?")+1,d.url.length)
							const params = str.split('&')
							const code = params[0].split('=')[1]
							d.cid = code
							if (d.state == '1') {
								this.navlist.push(d);
								// this.secondsList[0] = d
							} else if (d.state == '2') {
								this.jingXuan.push(d);
								this.secondsList.push(d);
								// this.secondsList[1] = d
							} else if (d.state == '3') {
								this.reMai.push(d);
								this.secondsList.push(d);
								// this.secondsList[2] = d
							} else if (d.state == '4') {
								this.meiRi.push(d);
								this.secondsList.push(d);
								// this.secondsList[3] = d
							} else if (d.state == '5') {
								this.pinTuan.push(d);
								this.secondsList.push(d);
								// this.secondsList[4] = d
							}
						}
						
					});
				})
			},
			// 商品分类
			classSelectP() {
				this.$http({
					url: this.$http.adornUrl('/selfActivity/state'),
					method: 'get',
					params: this.$http.adornParams({
						state:10,
						'languageType': this.version
					})
				}).then(({data}) => {
					this.navList1 = data.data
			
				})
			},
			// 获取商品数据
			dataSelect() {
				this.tableDataLoading= true
				if (this.title == '热卖榜单'||this.classId==21 || this.classId==1) {
					this.$http({
						url: this.$http.adornUrl('/goods/selling'),
						method: 'get',
						params: this.$http.adornParams({
							'page': this.page - 1,
							'size': this.size,
							'sort': this.sort,
							'languageType': this.version
						})
					}).then(({
						data
					}) => {
						this.tableDataLoading= false
						// this.dataList = data.data
						if(this.page==1){
							this.dataList = data.data
							this.dataListY = false
						}else{
							if(data.data.content.length==0){
								this.dataListY = true
								console.log('this.dataListY---111--------',this.dataListY)
							}else{
								this.dataList.content = [...this.dataList.content,...data.data.content]
								this.dataListY = false
							}
							
						}
					})
				}  else if (this.title == '精选好物') {
					this.$http({
						url: this.$http.adornUrl('/goods/selectGoods'),
						method: 'get',
						params: this.$http.adornParams({
							'sort': this.sort,
							'page': this.page - 1,
							'size': this.size,
						})
					}).then(({
						data
					}) => {
						this.tableDataLoading= false
						if (data.status == 0) {
							// this.dataList = data.data
							if(this.page==1){
								this.dataList = data.data
								this.dataListY = false
							}else{
								if(data.data.content.length==0){
									this.dataListY = true
									console.log('this.dataListY---111--------',this.dataListY)
								}else{
									this.dataList.content = [...this.dataList.content,...data.data.content]
									this.dataListY = false
								}
								
							}
						}
					})
				}else {
					this.$http({
						url: this.$http.adornUrl('goods/userList'),
						method: 'get',
						params: this.$http.adornParams({
							'page': this.page - 1,
							'size': this.size,
							'sort': this.sort,
							'type': this.type
						})
					}).then(({
						data
					}) => {
						this.tableDataLoading= false
						// this.dataList = data.data
						if(this.page==1){
							this.dataList = data.data
							this.dataListY = false
						}else{
							if(data.data.content.length==0){
								this.dataListY = true
								console.log('this.dataListY---111--------',this.dataListY)
							}else{
								this.dataList.content = [...this.dataList.content,...data.data.content]
								this.dataListY = false
							}
							
						}
					})
				}

			},
			// 获取轮播图
			bannerSelect() {
				this.$http({
					url: this.$http.adornUrl('/advert/list'),
					method: 'get',
					params: this.$http.adornParams({
						type: 2,
						'languageType': this.version
					})
				}).then(({
					data
				}) => {
					this.bannerList = data.data
				})
			},
			// 获取用户信息
			userSelect() {
				this.$http({
					url: this.$http.adornUrl('/user/' + this.userId),
					method: 'get',
					params: this.$http.adornParams({})
				}).then(({
					data
				}) => {
					if (data.status == 0) {
						this.isLogin = true
						this.relationId = data.data.relationId
						this.image_url = data.data.image_url
						this.nickName = data.data.nickName
						this.invitationCode = data.data.invitationCode
						this.phone = data.data.phone
						if (data.data.gradeDes) {
							this.dengji = data.data.gradeDes;
						} else {
							this.dengji = '已邀请0人';
						}
						if (data.data.gradeNumber) {
							// this.dengjides = data.data.gradeNumber;
							if (data.data.gradeNumber == '还可邀请0人') {
								this.dengjides = '已到达最高等级';
							} else {
								this.dengjides = data.data.gradeNumber;
							}
						} else {
							// this.dengjides = '还可邀请0人'
							// let number = this.$queue.invitaionNum();
							// this.dengjides = '还可邀请' + number + '人';
						}
						this.$cookie.set('relationId', data.data.relationId)
						this.$cookie.set('image_url', data.data.image_url)
						this.$cookie.set('nickName', data.data.nickName)
						this.$cookie.set('phone', data.data.phone)
						console.log('@@@@@@@@',this.$cookie.get('nickName'))
					}
				})
			},
			// 商品数据分类
			getOrderCount() {
				this.$http({
					url: this.$http.adornUrl('/orders/count?userId=' + this.userId),
					method: 'get',
					params: this.$http.adornParams({})
				}).then(({
					data
				}) => {
					if (data.status === 0) {
						this.dingdanCountList = data.data;
					}
				})
			},
			getLeftList() {
						console.log('开始获取分类数据，语言版本:', this.version);
						this.$http({
							url: this.$http.adornUrl('/goodsType/list'),
							method: 'get',
							params: this.$http.adornParams({
								'languageType': this.version
							})
						}).then(({
							data
						}) => {
							console.log('API返回数据:', data);
							if (data && data.status === 0) {
								console.log('原始分类数据:', data.data);
								// 保存完整的分类数据
								this.allCategories = data.data || [];
								// 尝试不同的过滤条件，确保获取一级分类
								this.leftList = (data.data || []).filter(item => !item.parentId || item.parentId === 0 || item.parentId === '0');
								console.log('过滤后的一级分类:', this.leftList);
								
							// 为每个一级分类添加品牌数据
								this.$http({
									url: this.$http.adornUrl('/common/type/284'),
									method: 'get'
								}).then(({data: brandData}) => {
									console.log('品牌数据:', brandData);
									if (brandData && brandData.status === 0) {
										// 处理品牌数据，将value和label转换为id和name
										const brands = (brandData.data || []).map(brand => ({
											id: brand.value,
											name: brand.label
										}));
										// 为每个一级分类添加品牌数据
										this.leftList.forEach(category => {
											category.children = brands;
											console.log(`分类 ${category.name} 的品牌数据:`, category.children);
										});
									}
								});
							} else {
								console.error('API返回错误:', data);
								this.$message({
									type: 'error',
									message: '分类数据加载失败，请刷新页面重试'
								})
							}
						}).catch(error => {
							console.error('API调用失败:', error);
							this.$message({
								type: 'error',
								message: '网络错误，分类数据加载失败'
							})
						})
					},
			switchover(item) {
				this.$router.push({
					path: '/productList2?id=' + item.id + '&title=' + item.title+ '&type=' + item.cid
				})
			},
goToProductList() {
			// 跳转到商品列表页面，不传递type参数，显示全部商品
			this.$router.push({
				path: '/productList'
			})
		},
	goShoppingGuide() {
  // 调用接口获取购物须知内容
  this.$http({
    url: this.$http.adornUrl('/common/type/248'),
    method: 'get',
    params: this.$http.adornParams({})
  }).then(({ data }) => {
    if (data && data.status === 0) {
      // 跳转到购物须知页面，并传递获取的内容
      this.$router.push({
        path: '/shoppingGuide',
        query: { content: encodeURIComponent(data.data.value) }
      })
    } else {
      // 如果获取失败，仍然跳转到购物须知页面
      this.$router.push('/shoppingGuide')
    }
  }).catch(() => {
    // 网络错误时，仍然跳转到购物须知页面
    this.$router.push('/shoppingGuide')
  })
},
			goToProductListWithType(type) {
				// 跳转到商品列表页面，传递type参数
				this.$router.push({
					path: '/productList?type=' + type
				})
			},
			
					goToProductListWithBrand(brandId) {
				// 跳转到商品列表页面，传递brand参数
				this.$router.push({
					path: '/productList?brand=' + brandId
				})
			},
			/* 登录 */
			goLogin() {
				this.$router.push({
					path: '/login'
				})
			},
			load() {
				this.count += 2
				this.page = this.page + 1
				console.log('this.dataListY-----------',this.dataListY)
				this.dataSelect()
				return this.dataListY = true
				
			},


		}
	}
</script>

<style scoped>
	.div1 {
		height: 100vh;
		overflow-x: hidden;
	}

	/* 导航 */
	.navigation {
		/* background: #FF2D55; */
		height: 40px;
		line-height: 40px;
		color: #fff;
	}

	.navList {
		width: 1200px;
		margin: 0 auto;
		display: flex;justify-content: space-between;
	}

	.navName {
		display: inline-block;
		width: 16.6%;
		text-align: center;
		cursor: pointer;
	}

	.active {
		background: #e5284c;
		color: #fff;
	}

	/* 第一部分 */
	.tong {
		width: 1200px;
		margin: 0 auto;
		    padding-top: 15px;
	}

	.ones {
		height: 450px;
	}

	.ist {
		display: inline-block;
		height: 440px;
		box-sizing: border-box;
	}

	.is_left {
		width: 20%;
		overflow-y: auto;
		margin-right: 1.5%;
		line-height: 40px;
		/* padding: 20px; */
		color: #fff;
		font-size: 14px;
		background: #fff;
		border-radius: 4px;
		float: left;
		background: #FF2D55;
	}
	.nameCl {
		transition: all 0.3s ease;
		position: relative;
	}
.nameCl:hover {
		background: #fff;
		color: #FF2D55 !important;
		border-radius: 2px;
	}

	.iconRight {
		position: absolute;
		right: 20px;
		top: 12px;
	}
	.listName:hover {
		color: #FF2D55;
		cursor: pointer;
		background: #fff;
	}
	.listName:hover .iconRight {
		color: #FF2D55;
		cursor: pointer;
		background: #fff;
	}
	.is_conts {
		width: 78.5%;
		/* margin-right: 1.5%; */
		height: 400px;
	}

	.bannerName {
		width: 100%;
		height: 100%;
	}

	.is_right {
		width: 25%;
		color: #333333;
		font-size: 14px;
		background: #fff;
		border-radius: 4px;
		box-sizing: border-box;
		height: 440px;
		float: right;
	}

	.rightTop {
		padding: 20px;
		height: 50px;
	}

	.imgTop {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		float: left;
	}

	.topR {
		margin-left: 60px;
		line-height: 36px;
	}

	.topL {
		margin-left: 60px;
		line-height: 50px;
		height: 50px;
	}

	.topL>div:hover {
		cursor: pointer;
	}

	.Rname {
		font-size: 20px;
	}

	.Ryaoqingma {
		font-size: 14px;
	}

	.rightVip {
		margin: 0 20px 15px;
		padding: 0;
		height: 40px;
		border-radius: 5px;
		background: #FF2D55;
		color: #fff;
	}

	.rightVip div {
		display: inline-block;
	}

	.rightNoVip {
		margin: 0 20px 15px;
		height: 40px;
		border-radius: 5px;
		background: #FF2D55;
		color: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		line-height: 40px;
		padding: 0 20px;
		font-size: 16px;
	}

	.rightBtn {
		width: 80px;
		height: 27px;
		text-align: center;
		font-size: 12px;
		color: #333;
		border-radius: 16px;
		z-index: 1;
		background: #fde3de;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.vipName {
		line-height: 40px;
		padding-left: 15px;
		font-size: 18px;
		font-weight: 600;
	}

	.vipKthy {
		background: #fff;
		font-size: 12px;
		color: #FF2D55;
		height: 20px;
		line-height: 20px;
		margin-left: 36%;
		padding: 0 6px;
		border-radius: 20px;
	}

	.vipKthy:hover {
		cursor: pointer;
	}

	.Rclass {
		padding: 0 20px 15px;
		border-bottom: 1px solid #F2F2F2;
		box-sizing: border-box;
		/* margin-top: 30px; */
		height: 168px;
	}

	.classList {
		display: inline-block;
		width: 40%;
		/* text-align: center; */
		position: relative;
		margin: 0 10px;
		margin: 0 10px;
	}

	.RlistNum {
		font-size: 24px;
		font-weight: 600;
		    margin-top: 10px;
	}

	.RlistName {
		font-size: 14px;
		/* position: absolute; */
		width: 100%;
		margin: 5px 0;
	}

	.Rbottom {
		padding: 15px 20px;

	}

	.bottomTitle {
		font-size: 20px;
		font-weight: 600;
		margin-bottom: 15px;
	}

	.bottomS {
		font-size: 12px;
		margin: 9px 0px;
	}

	.bottomList {
		padding: 15px 0;
	}

	.listI {
		display: inline-block;
		width: 32%;
		text-align: center;
		position: relative;
	}

	.bottomImg {
		width: 34px;
	}
	.bottomName{
		position: absolute;
	}
	.listI1 {
		display: inline-block;
		width: 100%;
		margin: 5px 0;
		/* text-align: center; */
		/* position: relative; */
	}
	
	.bottomImg1 {
		width: 20px;
	}
	.bottomName1{
		/* position: absolute; */
		display: inline-block;
		position: relative;
		bottom: 3px;
		    margin-left: 5px;
	}

	/* 第二部分 */
	.seconds {
		background: url(../../assets/index/bg.png) no-repeat;
		background-size: 100% 100%;
		box-sizing: border-box;
		height: 275px;
		border-radius: 5px;
	}

	.secondsleft {
		width: 15%;
		float: left;
		color: #fff;
		font-size: 18px;
		padding: 20px;
		box-sizing: border-box;
	}

	.secondsleft_title {
		font-size: 30px;
		font-weight: 600;
		line-height: 40px;
	}

	.secondsleft_dixy {
		/* height: 177px; */
	}

	.chakan {
		cursor: pointer;
	}

	.secondsRight {
		margin-left: 16%;
		border: none;
		border-radius: 6px;
		background: #fff;
		border: 1px solid #FF2D55;
		box-sizing: border-box;
	}

	.secondsRight_list {
		display: inline-block;
		width: 20%;
		box-sizing: border-box;
		padding: 20px;
		font-size: 18px;

	}

	.secondsRight_title {
		line-height: 30px;
		color: #333;
		font-weight: 600;
		text-align: center;
	}

	.secondsRight_sm {
		font-size: 13px;
		color: #999;
		margin-bottom: 20px;
		text-align: center;
	}

	.secondsRight_img {
		width: 100%;
		height: 161px;
	}

	/* 第三部分 */
	.navList2 {
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 18px;
		color: #333;
		background: #fff;
		border-radius: 2px;
	}

	.navName1 {
		display: inline-block;
		width: 16.66%;
		text-align: center;
		cursor: pointer;
		border-radius: 4px;
	}

	.active1 {
		background: #FF2D55;
		color: #fff;
	}

	/* 筛选表格 */
	.table_main table {
		width: 100%;
	}

	.table_main {
		border: 1px solid #e8e8e8;

	}

	table tr {
		/* border-bottom: 1px solid #e8e8e8; */
		background: #fff;
	}

	table tr th {
		padding: 16px 24px;
		/* border-right: 1px solid #e8e8e8; */
		/* border-bottom: 1px solid #e8e8e8; */
	}

	table tr td {
		padding: 16px 24px;
		/* border-right: 1px solid #e8e8e8; */
		border-bottom: 1px solid #e8e8e8;
	}

	table th {
		color: rgba(0, 0, 0, .85);
		font-weight: 400;
		font-size: 14px;
		line-height: 1.5;
	}

	.border-rt {
		border-right: none !important;
	}

	.border-bt {
		border-bottom: none !important;
	}

	.left-th {
		color: #333;
		width: 50px;
		line-height: 50px;
	}

	.right-th {
		text-align: left;
		padding-left: 30px;
	}

	.className {
		display: inline-block;
		/* width: 50px; */
		background-color: #fff;
		font-size: 14px;
		color: #333;
		margin: 10px 5px;
		padding: 0 20px;
		text-align: center;
		cursor: pointer;
	}

	.active2 {
		background: #FF2D55;
		color: #fff;
		border-radius: 4px;
	}

	.yxl {
		width: 70px;
		margin: 0 50px 0 10px;
		border: 1px solid #E6E6E6;
		height: 30px;
		line-height: 30px;
		border-radius: 4px;
	}

	.jiage1 {
		margin: 0 20px;
		width: 50px;
	}

	.emptyWrap {
		width: 100%;
		text-align: center;
		margin: 80px 0;
	}

	.emptyWrap>div {
		font-size: 24px;
		font-weight: 700;
		color: #999999;
	}
</style>



// WEBPACK FOOTER //
// src/views/homePage/index.vue